function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#262C37",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeDasharray: "4,4",
  strokeOpacity: 0.25,
  d: "M393 4h114v74H393V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.282 32h-19.634l-6.465-6L426 38h3v18h42V38h3zM426 38h48m-64.5 9.5h80",
  opacity: 0.25
}));

function SvgSeparate4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 82
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iODIiIHZpZXdCb3g9IjAgMCA5MDAgODIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBzdHJva2U9IiMyNjJDMzciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlLWRhc2hhcnJheT0iNCw0IiBzdHJva2Utb3BhY2l0eT0iLjI1IiBkPSJNMzkzIDRoMTE0djc0SDM5M1Y0eiIvPgogICAgICAgICAgICA8ZyBvcGFjaXR5PSIuMjUiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTQ2Ni4yODIgMzJoLTE5LjYzNGwtNi40NjUtNkw0MjYgMzhoM3YxOGg0MlYzOGgzek00MjYgMzhoNDhNNDA5LjUgNDcuNWg4MCIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgSeparate4 as ReactComponent };